import { PROJECT_NOTIFICATION_ENTITY_TYPE } from './constants';
import type { ProjectNotificationType } from './types';

export const getNotificationProjectId = (notification: ProjectNotificationType): string | null => {
  const { metadata } = notification;
  if (!metadata) return null;

  return metadata.entityType === PROJECT_NOTIFICATION_ENTITY_TYPE.PROJECT
    ? metadata.entityId
    : (metadata.projectId ?? null);
};
